<script setup lang="ts">
  import type { QsoConversionError } from '@/lib/AdifExporter';

  const props = defineProps<{
    failures: QsoConversionError[];
    totalQsos: number;
  }>();

  const previewCount = 5;
  const previewFailures = props.failures.slice(0, previewCount);
  const remaining = props.failures.length - previewFailures.length;
</script>

<template>
  <div data-testid="toast__adif-export-partial">
    <div class="font-bold text-sm mb-1" data-testid="toast__header">
      <span
        class="inline-flex items-center rounded-md bg-gray-100 px-1.5 py-0.5 text-xs font-bold uppercase text-amber-500"
        data-testid="toast__badge">
        Warning
      </span>
      <span class="uppercase ml-2" data-testid="toast__title">ADIF Export - Partial</span>
    </div>
    <div data-testid="toast__body" class="text-sm">
      <p class="mb-1">
        Skipped {{ props.failures.length }} of {{ props.totalQsos }} QSOs that could not be converted.
        The remaining {{ props.totalQsos - props.failures.length }} were exported.
      </p>
      <ul class="list-disc pl-5">
        <li v-for="(failure, index) in previewFailures" :key="index">
          {{ failure.qsoDetails.call || 'unknown' }}
          <span v-if="failure.qsoDetails.qsoDateTime"> @ {{ failure.qsoDetails.qsoDateTime }}</span>
        </li>
      </ul>
      <p v-if="remaining > 0" class="mt-1 italic">...and {{ remaining }} more.</p>
    </div>
  </div>
</template>
